import { createSlice } from "@reduxjs/toolkit";
import { logOut } from "../../config/firebaseConfig";

export const ADMIN_UIDS = [
  "xXN10FCqSHZlkuHNqR5L6ia1jDv1", // zackdvlp@gmail.com
  "JWEAliJbkVfFs3cl2U0FMWTZHWA2", // kankuzacharie@gmail.com
];

const initialState = {
  userId: null,
  station: null,
  quin: null,
  isAdmin: false,
  role: null, // 'admin' | 'gestock' | null (regular pompist)
  displayName: null,
  viewAsUid: null,
  isLoading: false,
  error: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,

  reducers: {
    loginStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },

    loginSuccess: (state, action) => {
      state.isLoading = false;
      state.userId = action.payload;
      state.isAdmin = ADMIN_UIDS.includes(action.payload);
      state.error = null;
    },

    loginFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    setStation: (state, action) => {
      state.station = action.payload;
    },

    setQuin: (state, action) => {
      state.quin = action.payload;
    },

    setAppUser: (state, action) => {
      // payload: { name, role } from app_users/{uid}
      const { name, role } = action.payload || {};
      state.displayName = name || null;
      state.role = role || null;
      if (role === "admin") state.isAdmin = true;
    },

    setViewAs: (state, action) => {
      // { uid, station, quin }
      state.viewAsUid = action.payload.uid;
      state.station = action.payload.station || null;
      state.quin = action.payload.quin || null;
    },

    clearViewAs: (state) => {
      state.viewAsUid = null;
      state.station = null;
      state.quin = null;
    },

    logout: (state) => {
      state.userId = null;
      state.station = null;
      state.quin = null;
      state.isAdmin = false;
      state.role = null;
      state.displayName = null;
      state.viewAsUid = null;
      logOut();
      localStorage.removeItem("userId");
      localStorage.removeItem("viewAsUid");
      localStorage.removeItem("viewAsStation");
      localStorage.removeItem("viewAsQuin");
      localStorage.removeItem("gestockPage");
      localStorage.removeItem("inGestock");
    },
  },
});

/** Returns the UID to use for all Firestore reads/writes.
 *  Admins viewing a station use viewAsUid; normal users use their own. */
export const selectActiveUid = (state) =>
  state.auth.viewAsUid || state.auth.userId;

export const {
  loginStart,
  loginSuccess,
  loginFailure,
  logout,
  setStation,
  setQuin,
  setAppUser,
  setViewAs,
  clearViewAs,
} = authSlice.actions;

export default authSlice.reducer;
